import * as React from "react";

const IconShareEmail: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="currentColor">
            <path
                fill="currentColor"
                d="M87,11 C86.4834375,11 85.9668751,10.8305626 85.5262499,10.4871874 L79,5.41250038 L79,12.5 C79,13.328125 79.6715627,14 80.5,14 L93.5,14 C94.3284378,14 95,13.3284378 95,12.5 L95,5.41250038 L88.4750004,10.4906254 C88.0343752,10.8312502 87.515625,11 87,11 Z M79.5090628,4.54062462 L86.1403122,9.70000076 C86.6462498,10.093751 87.3549995,10.093751 87.8609371,9.70000076 L94.4921875,4.54062557 C94.7843752,4.29062462 95,3.90625 95,3.5 C95,2.67156219 94.328125,2 93.5,2 L80.5,2 C79.6715627,2 79,2.67156219 79,3.5 C79,3.90625 79.1878123,4.29062462 79.5090623,4.54062462 L79.5090628,4.54062462 Z"
                transform="translate(-79 -2)"
            />
        </svg>
    );
};

export default React.memo(IconShareEmail);
